/** Shared formatters + tiny cells for the covered-call SEO pages. */

export function fmtPct(v, dp = 2, signed = false) {
  if (v == null || Number.isNaN(v)) return '—';
  const s = signed && v > 0 ? '+' : '';
  return `${s}${Number(v).toFixed(dp)}%`;
}

export function fmtMoney(v, dp = 2) {
  if (v == null || Number.isNaN(v)) return '—';
  return `$${Number(v).toFixed(dp)}`;
}

export function fmtAum(v) {
  if (v == null || Number.isNaN(v)) return '—';
  const n = Number(v);
  if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (n >= 1e9) return `$${(n / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(0)}M`;
  return `$${Math.round(n).toLocaleString()}`;
}

export function fmtDate(s) {
  if (!s) return '—';
  const d = new Date(s.length === 10 ? `${s}T00:00:00Z` : s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

export function TotalReturnCell({ value }) {
  if (value == null) {
    return <span className="text-slate-400" title="Needs 12 months of price and distribution history">—</span>;
  }
  const good = value >= 0;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md font-bold tabular-nums ${good
        ? 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-400'
        : 'bg-rose-50 dark:bg-rose-950/40 text-rose-700 dark:text-rose-400'}`}
    >
      {value > 0 ? '+' : ''}{value.toFixed(1)}%
    </span>
  );
}
